<!--产品优势-->

<template>
    <div class='all-bodySpecial all-bodyBg'>
        <div class='child-body'>
            <div class="child-body-name">{{name}}</div>
            <ul>
                <li>
                    <!-- 奇数 -->
                    <div>
                        <div class='advantageAlll' v-for="(item,index) of data">
                            <div class="imgBox">
                                <img :src="item.img" alt="1" v-if="(index % 2) != '0'">
                            </div>
                            <div :class='{"advantage-container":(index % 2) != "0","advantage-containerTwo":index % 2=="0"}'>   
                                <div v-for="(items,indexs) of item.data">
                                    <span class="advantage-num">{{items.title}}</span>
                                    <div class="advantage-content">
                                        {{items.html}}
                                    </div>
                                </div>
                            </div>
                            <div class="imgBox">
                                <img :src="item.img" alt="2" v-if="(index % 2) == '0'">
                            </div>
                        </div>
                    </div> 
                </li>
            </ul>
        </div>   
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data','name']
}
</script>
<style scoped>
.all-bodySpecial{
    width: 100%;
    height: auto;  
}
.child-body-name{
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #262626;
    margin-bottom: 50px;
    text-align: center;
}
.advantageAlll{
    display: flex;
}
.advantageAlll img{
    display: inline-block;
    width: 525px;
    height: 370px;
}
.advantage-container{
    padding:35px 0px 0px 75px; 
}
.advantage-containerTwo{
    padding:35px 75px 0px 0px; 
}
.advantage-num{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303133;
    display: inline-block;
    margin-bottom: 18px;
}
.advantage-content{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #606266;
    line-height: 30px;
    margin-bottom: 55px;
}
.imgBox img{
    width: 525px;
}
</style>